import { useSiteData } from "../app/SiteDataContext";
import SectionHeading from "../components/ui/SectionHeading";
import Badge from "../components/ui/Badge";
import Seo from "../components/shared/Seo";
import { createProfilePageSchema } from "../seo/schema";

function AboutPage() {
  const { settings } = useSiteData();
  const siteProfile = settings.siteProfile;
  const featuredMetrics = settings.featuredMetrics || [];
  const expertiseAreas = settings.expertiseAreas || [];
  const technologyStack = settings.technologyStack || [];
  const careerHighlights = settings.careerHighlights || [];
  const skillCards = settings.skillCards || [];

  return (
    <div className="page-stack">
      <Seo
        title="Hakkimda"
        description="Onur Atabay'in uzmanlik alanlari, teknoloji stack'i, kariyer ozeti ve premium frontend yaklasimi."
        path="/hakkimda"
        schema={[createProfilePageSchema(siteProfile)]}
        keywords={["hakkimda", "frontend uzmanligi", "teknoloji stack"]}
      />
      <section className="glass-panel page-hero">
        <SectionHeading
          eyebrow="About Me"
          title="Kurumsal netlik, kisisel ton ve yuksek kalite algisi ayni yerde bulusabilir."
          description={siteProfile.extendedBio}
        />
      </section>

      <section className="content-section two-column-layout">
        <div className="glass-panel">
          <SectionHeading
            eyebrow="Ben kimim"
            title="Urun kalitesini sadece UI degil, karar sistemi olarak ele aliyorum"
            description="Tasarim sistemleri, reusable component mantigi ve editor dostu icerik akislari benim icin ayni urunun parcalari."
          />
          <div className="tag-row">
            {expertiseAreas.map((item) => (
              <Badge key={item}>{item}</Badge>
            ))}
          </div>
        </div>

        <div className="stats-grid">
          {featuredMetrics.map((item) => (
            <article key={item.label} className="glass-card stat-card">
              <strong>{item.value}</strong>
              <h3>{item.label}</h3>
              <p>{item.note}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="content-section">
        <SectionHeading
          eyebrow="Tech Stack"
          title="Uretim hattim"
          description="Frontend deneyimin kalitesini arttiran, olgun ve gelistirilebilir teknoloji secimleri."
        />
        <div className="tag-row tag-row-large">
          {technologyStack.map((item) => (
            <span key={item} className="tag-pill">
              {item}
            </span>
          ))}
        </div>
      </section>

      <section className="content-section">
        <SectionHeading
          eyebrow="Career"
          title="Kariyer ozeti"
          description="Her asamada ayni seye odaklandim: kaliteli arayuzlerin is etkisi ureten bir sistem haline gelmesi."
        />
        <div className="timeline">
          {careerHighlights.map((item) => (
            <article key={item.title} className="glass-card timeline-item">
              <p className="eyebrow">{item.period}</p>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="content-section">
        <SectionHeading
          eyebrow="Strengths"
          title="Yetenek kartlari"
          description="Yuksek algi oluşturan dijital deneyimlerde en cok deger urettigim alanlar."
        />
        <div className="card-grid card-grid-three">
          {skillCards.map((item) => (
            <article key={item.title} className="glass-card info-card">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}

export default AboutPage;
